import { ResourceProps } from 'react-admin';
import { VideoSettings } from '@mui/icons-material';

const Index: ResourceProps = {
  icon: VideoSettings,
  name: 'subscription_details',
};

export default Index;
